import { useEffect, useState } from "react";
import { campaignState, fmtDate } from "@/lib/bf";

const pad = (n) => String(n).padStart(2, "0");
const LABEL = { soon: "Începe în", live: "Se încheie în", over: "Campania s-a încheiat" };

export default function Countdown({ cfg }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const { phase, target } = campaignState(cfg, now);
  const left = Math.max(0, target - now);
  const parts = [
    ["zile", Math.floor(left / 86400000)],
    ["ore", Math.floor(left / 3600000) % 24],
    ["min", Math.floor(left / 60000) % 60],
    ["sec", Math.floor(left / 1000) % 60],
  ];
  return (
    <div className={`bf-count is-${phase}`} data-testid="bf-countdown">
      <span className="bf-count-label" data-testid="bf-countdown-label">{LABEL[phase]}</span>
      {phase !== "over" && (
        <div className="bf-count-grid">
          {parts.map(([k, v]) => (
            <div key={k} data-testid={`bf-countdown-${k}`}><b>{pad(v)}</b><small>{k}</small></div>
          ))}
        </div>
      )}
      <span className="bf-count-dates">{fmtDate(cfg.start)} – {fmtDate(cfg.end)} {cfg.end.slice(0, 4)}</span>
    </div>
  );
}
